export interface SequenceSentStatus {
  id: number;
  name: string;
}

/** Espelha as constantes de App\Models\SequenceSentStatus no backend. */
export enum SequenceSentStatusId {
  PENDING = 1,
  QUEUED = 2,
  SENT_WITHOUT_CONFIRMATION = 3,
  SENT = 4,
  CANCELED = 5,
  PROCESSING = 6,
}
